import React, { VFC } from 'react';
import SnsLink from '~/src/feature/Ambassador/components/SnsLink';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    marginRight: theme.spacing(1),
    width: '20px',
    height: '20px',
  },
}));

interface Props {
  twitter?: string;
  instagram?: string;
  youtube?: string;
}

const SnsLinks: VFC<Props> = ({ twitter, instagram, youtube }) => {
  const classes = useStyles();
  return (
    <>
      {twitter && (
        <SnsLink url={twitter}>
          <TwitterIcon classes={{ root: classes.icon }} />
          {twitter}
        </SnsLink>
      )}
      {instagram && (
        <SnsLink url={instagram}>
          <InstagramIcon classes={{ root: classes.icon }} />
          {instagram}
        </SnsLink>
      )}
      {youtube && (
        <SnsLink url={youtube}>
          <YouTubeIcon classes={{ root: classes.icon }} />
          {youtube}
        </SnsLink>
      )}
    </>
  );
};

export default SnsLinks;
